import { MRT_ColumnDef, useMaterialReactTable, MaterialReactTable } from 'material-react-table'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import { AlertType, Clientes, LanctoCartao, RetAPI, bgLineGridColorDark, bgLineGridColorLight, corBgGrid } from '../../Utils/Types'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import { ThemeProvider, createTheme } from '@mui/material'
import { Tooltip } from 'react-tooltip'
import { useNavigate } from 'react-router-dom'
import { ModalExcluirDados } from '../Modal/ModalExcluirDados'
import { ClientesService } from '../../Pages/Clientes/ClientesService'
import { Funcoes } from '../../Utils/Funcoes'
import { RiEdit2Fill } from 'react-icons/ri'
import { FaTrashAlt } from 'react-icons/fa'
import moment from 'moment'
import { LanctoCartaoService } from '../../Pages/LancamentoCartao/LanctoCartaoService'

type Props = {
    lanctoCartao: LanctoCartao[],
    handleUpdateLanctoCartaoList: () => void,
    handleSelectItemClick: (id: number, selected: boolean) => void,
    handleColumnLiqClick: () => void,
    tipo: TipoStatus,
    id_select: boolean,
    selectedAll: boolean,
}

export type TipoStatus = | "A" | "B"

type VisibilityState = Record<string, boolean>

interface RowData {
    id: number,
    id_empresa: number,
    id_user_insert: number,
    id_user_last_update: number,
    id_user_exclusao: number,
    id_venda: number,
    dt_chegada: string,
    dt_vencimento: string,
    dt_cadastro: string,
    dt_last_update: string,
    dh_exclusao: string,
    motivo_exclusao: string,
    name_user_insert: string,
    name_user_last_update: string,
    name_user_delete: string,
    hora: string,
    valor: number,
    valor_receber: number,
    id_bandeira: number,
    numero_transacao?: string,
    id_cliente: number
    name_bandeira: string,
    name_cliente: string,
    selected: boolean,
}


export const GridLanctoCartao = React.memo(({ lanctoCartao, handleUpdateLanctoCartaoList, handleSelectItemClick, handleColumnLiqClick, tipo, id_select, selectedAll }: Props) => {

    const defaultJson = useMemo(() => {
        return (

            localStorage.getItem("@commerce/column_grid_lanctoCartao")
                ? JSON.parse(localStorage.getItem("@commerce/column_grid_lanctoCartao") || '')
                : {
                    acao: true,
                    numero_transacao: true,
                    hora: true,
                    id_venda: true,
                    dt_chegada: true,
                    dt_vencimento: true,
                    valor: true,
                    valor_receber: true,
                    name_cliente: true,
                    name_user_insert: true,
                    name_bandeira: true,
                }
        )
    }, [])

    const [idExcluir, setIdExcluir] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [modalShow, setModalShow] = useState(false)
    const [feedBackVisible, setFeedBackVisible] = useState(false)
    const [messageFeedBack, setMessageFeedBack] = useState("")
    const [alertType, setAlertType] = useState<AlertType>("SUCCESS")
    const [state, setState] = useState(false)
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(defaultJson)

    const [lanctoCartoes, setLanctoCartoes] = useState<LanctoCartao[]>([])
    const [nomeLanctoCartao, setNomeLanctoCartao] = useState("")

    let user = useSelector(state => selectUser(state))

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EFFECT -------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    useEffect(() => {
        setLanctoCartoes([])

        const timer = setTimeout(() => {
            const newColumnVisibility = { ...columnVisibility }

            // Só define essas se houver id_select
            if (id_select) {
                newColumnVisibility.liquidar = tipo === "A"
                newColumnVisibility.estornar = tipo === "B"
            } else {
                newColumnVisibility.liquidar = false
                newColumnVisibility.estornar = false
            }

            setColumnVisibility(newColumnVisibility)
            clearTimeout(timer)
        }, 150)

        return () => clearTimeout(timer)

    }, [tipo, id_select])

    useEffect(() => {
        setLanctoCartoes(lanctoCartao)
    }, [lanctoCartao])

    useEffect(() => {
        localStorage.setItem("@commerce/column_grid_lanctoCartao", JSON.stringify(columnVisibility))
    }, [columnVisibility])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EXCLUIR e FOCUS ----------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const handleExcluir = useCallback(async (motivo: string, senha: string) => {

        setFeedBackVisible(false)
        setIsLoading(true)

        try {

            const retApi: RetAPI = await LanctoCartaoService.Delete(idExcluir, motivo, senha)

            if (!retApi.error) {
                setFeedBackVisible(true)
                setAlertType("SUCCESS")
                setMessageFeedBack(`Lançamento de cartão excluído com sucesso`)

                handleUpdateLanctoCartaoList()

            } else {
                setFeedBackVisible(true)
                setAlertType("DANGER")
                setMessageFeedBack(retApi.msg || ``)
                setIsLoading(false)
                //setModalShow(false)
            }

        } catch (error) {

            setIsLoading(false)
            setFeedBackVisible(true)
            setAlertType("DANGER")
            setMessageFeedBack(`Não foi possível excluir o lançamento de cartão. Por favor, tente novamente`)
        }

    }, [idExcluir])

    const fecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        if (alertType == 'SUCCESS') {
            setModalShow(false)
            setNomeLanctoCartao("")
        }

    }, [alertType])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        setModalShow(false)
        setNomeLanctoCartao("")
    }, [])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TEMAS --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const theme = createTheme({
        palette: {
            mode: user.modeDark,
            background: {
                default:
                    user.modeDark === 'light' ? '#fff' : '#475569',
            },
        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- NAVEGAÇÃO ----------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const navigate = useNavigate()

    const navegarTelaLanctoEdit = (id: number) => {
        navigate(`/lanctoCartao/edit/${id}`)
    }


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- COLUNAS ------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const handleCheckBoxClick = (id: number, selected: boolean) => {

        setState(!state)
        handleSelectItemClick(id, selected)
    }


    const colunas = useMemo<MRT_ColumnDef<LanctoCartao>[]>(() => [

        /* --------------------------------------------------------------------------------------------------------------------------------------------------------- */
        {
            accessorKey: 'estornar',
            header: '[Estornar]',
            size: 150,
            visibleInShowHideMenu: tipo === 'B' ? true : false,
            muiTableBodyCellProps: { align: 'center' },
            muiTableHeadCellProps: { align: 'center' },
            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (

                    <div className={`w-full h-[30px]`} >

                        <input
                            id={'checkbox-' + rowData.id}
                            aria-label={rowData.id.toString()}
                            type='checkbox'
                            onChange={() => handleCheckBoxClick(rowData.id, rowData.selected)}
                            checked={!!rowData.selected}
                            className={`h-5 w-5 mx-2 cursor-pointer`}
                        />

                        <Tooltip
                            style={{ backgroundColor: 'rgb(30, 41, 59)', zIndex: 9999 }}
                            id={'tooltip-checkbox-' + rowData.id}
                            anchorSelect={'#checkbox-' + rowData.id}
                            positionStrategy='fixed' >
                            <span >
                                Selecione para <br />
                                estornar
                            </span>
                        </Tooltip>

                    </div>
                )
            }
        },

        {
            accessorKey: 'liquidar',
            Header: (props) => {
                return <input type='checkbox' className={`accent-blue-500 h-5 w-5 outline-none cursor-pointer`} checked={selectedAll} onChange={handleColumnLiqClick} />
            },
            header: '',
            size: 120,
            visibleInShowHideMenu: tipo === 'A' ? true : false,
            muiTableBodyCellProps: { align: 'center' },
            muiTableHeadCellProps: { align: 'center' },
            Cell: ((cell: any) => {

                const rowData = cell.row.original as RowData

                return (
                    <div className={`w-full h-[30px]`}>

                        <input
                            id={'checkbox-' + rowData.id}
                            aria-label={rowData.id.toString()}
                            type='checkbox'
                            onChange={() => handleCheckBoxClick(rowData.id, rowData.selected)}
                            className={`accent-blue-500 h-5 w-5 outline-none cursor-pointer`}
                            checked={!!rowData.selected}
                        />

                        <Tooltip
                            style={{ backgroundColor: 'rgb(30, 41, 59)' }}
                            id={'tooltip-checkbox-' + rowData.id}
                            anchorSelect={'#checkbox-' + rowData.id}
                            positionStrategy='fixed' >
                            <span>
                                Selecione para <br />
                                baixar
                            </span>
                        </Tooltip>
                    </div>

                )
            }
            )
        },

        {
            accessorKey: 'acao', header: 'Ações', visibleInShowHideMenu: true, size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                const navegar = () => {
                    navegarTelaLanctoEdit(rowData.id)
                }

                const handleExcluirClick = () => {

                    const timerExcluir = setTimeout(() => {

                        setIdExcluir(rowData.id)
                        setNomeLanctoCartao(rowData.numero_transacao || '')
                        setModalShow(true)

                        let divPerfil = document.getElementById('div-perfil') as HTMLDivElement

                        if (divPerfil) {
                            divPerfil.classList.add('hidden')
                        }

                        let menuFiltro = document.getElementById("divMenuFiltroLanctoCartao") as HTMLDivElement
                        let menuInputs = document.getElementById("divInputsLanctoCartao") as HTMLDivElement
                        let bodySearchBandeira = document.getElementById("bodySearchBox-bandeira") as HTMLDivElement
                        let bodySearchVendedor = document.getElementById("bodySearchBox-vendedor") as HTMLDivElement
                        let bodySearchCliente = document.getElementById("bodySearchBox-cliente") as HTMLDivElement

                        if (menuFiltro) {

                            bodySearchBandeira.classList.remove("visible")
                            bodySearchVendedor.classList.remove("visible")
                            bodySearchCliente.classList.remove("visible")

                            menuInputs.classList.add("invisible")

                            const timer = setTimeout(() => {
                                menuFiltro.classList.remove("max-h-[1000px]")
                                menuFiltro.classList.add("max-h-[0px]")
                                clearTimeout(timer)
                            }, 100)
                        }

                        clearTimeout(timerExcluir)
                    }, 0)

                }

                return (

                    <>
                        <div className={`flex justify-start w-full`}>

                            <button
                                onClick={navegar} data-tooltip-id={'tooltip-editar-' + rowData.id} id={'btn-editar-' + rowData.id}
                                className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-sky-600 w-[30px] h-[30px] rounded-md 
                                          bg-sky-500`}>
                                <RiEdit2Fill size="20px" />
                                <Tooltip style={{ backgroundColor: 'rgb(14, 165, 233)' }} id={'tooltip-editar-' + rowData.id} anchorSelect={'#btn-editar-' + rowData.id} positionStrategy="fixed" place='top-start'  >
                                    <span className={`font-sans font-medium text-[13px]`}>Editar</span>
                                </Tooltip>
                            </button>

                            <button
                                onClick={handleExcluirClick} data-tooltip-id={'tooltip-excluir-' + rowData.id} id={'btn-excluir-' + rowData.id}
                                className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                          bg-red-500 ml-2`} >
                                <FaTrashAlt size="18px" />
                                <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-excluir-' + rowData.id} anchorSelect={'#btn-excluir-' + rowData.id} positionStrategy="fixed"  >
                                    <span className={`font-sans font-medium text-[13px]`}>Excluir</span>
                                </Tooltip>
                            </button>

                        </div>
                    </>

                )
            }
        },

        {
            accessorKey: 'numero_transacao', visibleInShowHideMenu: true, header: 'Transação', size: 100, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.numero_transacao ? rowData.numero_transacao : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'hora', visibleInShowHideMenu: true, header: 'Horas', size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.hora ? rowData.hora : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'id_venda', visibleInShowHideMenu: true, header: 'Venda', size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.id_venda ? rowData.id_venda : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'dt_chegada', visibleInShowHideMenu: true, header: 'Data de Chegada', size: 100, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.dt_chegada ? moment(rowData.dt_chegada).format('DD/MM/YYYY') : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'dt_vencimento', visibleInShowHideMenu: true, header: 'Data de Vencimento', size: 100, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.dt_vencimento ? moment(rowData.dt_vencimento).format('DD/MM/YYYY') : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'valor', visibleInShowHideMenu: true, header: 'Valor', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.valor ? Funcoes.numberFormat(rowData.valor, 'currency') : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'valor_receber', visibleInShowHideMenu: true, header: 'Valor a Receber', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.valor_receber ? Funcoes.numberFormat(rowData.valor_receber, 'currency') : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'name_cliente', visibleInShowHideMenu: true, header: 'Cliente', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.name_cliente ? rowData.name_cliente : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'name_user_insert', visibleInShowHideMenu: true, header: 'Vendedor', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.name_user_insert ? rowData.name_user_insert : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'name_bandeira', visibleInShowHideMenu: true, header: 'Bandeira', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.name_bandeira ? rowData.name_bandeira : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

    ], [lanctoCartao])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TABLE --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const table = useMaterialReactTable({
        paginationDisplayMode: 'pages',
        columns: colunas,
        data: lanctoCartoes,
        autoResetPageIndex: false,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,
        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },

            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        localization: MRT_Localization_PT_BR,
        enableEditing: false,
        enableTopToolbar: false,
        enableColumnActions: false,
        enableColumnFilters: false,
        enableHiding: false,
        enableFilters: false,
        enableMultiSort: false,
        enableSorting: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        onColumnVisibilityChange: setColumnVisibility,
        state: { columnVisibility },
    })

    return (
        <>
            <ThemeProvider theme={theme}>

                <MaterialReactTable table={table} />

            </ThemeProvider>

            <ModalExcluirDados
                show={modalShow}
                isLoading={isLoading}
                message={`Deseja excluir o lançamento - ${nomeLanctoCartao || ''}?`}
                alertType={alertType}
                feedBackVisible={feedBackVisible}
                messageFeedBack={messageFeedBack}
                closeModalEvent={fecharModalExcluirDados}
                excluirEvent={handleExcluir}
                fecharModalEvent={buttonFecharModalExcluirDados}
            />

        </>
    )
})